module.exports = __webpack_public_path__ + "img/cross_icon.b9f16863.svg";